/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Notes_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Record ids are ULIDs. List endpoints paginate with ?cursor=." |
*
* @param {External_Apis_Field_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_notes_placeholder = /** @type {((inputs?: External_Apis_Field_Notes_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Notes_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz-IDs sind ULIDs. Listen-Endpunkte paginieren mit ?cursor=.")
	return /** @type {LocalizedString} */ ("Record ids are ULIDs. List endpoints paginate with ?cursor=.")
});